var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdotickmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65972 5.59092C3.47592 5.84038 3.1897 5.9937 2.88023 6.00894C2.57076 6.02434 2.27103 5.89961 2.06367 5.66931L0.205435 3.60717C-0.0898973 3.27963 -0.0636631 2.77474 0.263873 2.47941C0.591723 2.18408 1.0963 2.21047 1.39163 2.53816L2.70633 3.99723C2.72581 4.01891 2.75409 4.03053 2.78315 4.02912C2.81237 4.0277 2.83907 4.01309 2.85651 3.98984L5.5588 0.324742C5.82036 -0.0302854 6.32022 -0.105846 6.67541 0.155868C7.03028 0.417583 7.10568 0.917448 6.84397 1.27232L3.65972 5.59092Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdotickmark);
export default __webpack_public_path__ + "static/media/idotickmark.5b1fd33c.svg";
export { ForwardRef as ReactComponent };